import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import Button from './Button';
import theme, { buttonReset } from '../../styles/theme';
import { defaultProps, formatOptions, propTypes } from './common';

class DropDown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: true,
    };
  }

  handleOnSelectChange = (e, value) => {
    const { onChange } = this.props;
    e.preventDefault();
    onChange(value);
    this.handleOpenCloseDropdown();
  };

  handleOpenCloseDropdown = () => {
    const { hidden } = this.state;
    this.setState({
      hidden: !hidden,
    });
  };

  render() {
    const { hidden } = this.state;
    const {
      all, classes, className, options, selected, buttonTheme,
    } = this.props;
    const selectedText = selected || 'All';
    return (
      <div className={cn(className, classes.container)}>
        { !hidden && (
          <div
            className={classes.dropDownClose}
            onClick={this.handleOpenCloseDropdown}
            role="presentation"
          />
        ) }
        <Button
          selected
          text={selectedText}
          className={classes.button}
          buttonTheme={buttonTheme}
          onClick={this.handleOpenCloseDropdown}
        />
        <span className={classes.iconWrapper}>
          <svg className={classes.icon} viewBox="0 0 8 8">
            <path fill="currentColor" d="M4 7l-8-8l1-1L4 5l7-7L12-1l-5 5z" />
          </svg>
        </span>
        { !hidden && (
          <ul className={classes.dropdownOptions}>
            {formatOptions(options, all).map(({ text, value }) => (
              <li key={text} className={classes.dropdownItem}>
                <button
                  type="button"
                  className={cn(classes.dropdownButton, selected === text && 'active', (typeof selected === 'undefined' && text === 'All') && 'active')}
                  onClick={e => this.handleOnSelectChange(e, value)}
                >
                  {text}
                </button>
              </li>
            ))}
          </ul>
        ) }
      </div>
    );
  }
}

DropDown.propTypes = {
  ...propTypes,
  onChange: PropTypes.func.isRequired,
  buttonTheme: PropTypes.shape({
    color: PropTypes.string.isRequired,
    selected: PropTypes.string.isRequired,
  }),
};
DropDown.defaultProps = { ...defaultProps };

export default injectSheet({
  container: {
    marginLeft: -8,
    marginRight: -8,
    position: 'relative',
    width: 'auto',
    maxWidth: 300,
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'calc(100% + 16px)',
      width: 'calc(100% + 16px)',
    },
  },
  dropdownOptions: {
    position: 'absolute',
    top: '100%',
    margin: '0 8px',
    left: 0,
    right: 0,
    listStyle: 'none',
    padding: 0,
    border: `1px solid ${theme.colors.borderDropdown}`,
    borderRadius: '2px',
    zIndex: 99998,
    backgroundColor: theme.colors.white,
    maxHeight: 308,
    overflow: 'hidden',
    overflowY: 'auto',
    width: '-webkit-fit-content',
    width: '-moz-fit-content', // eslint-disable-line no-dupe-keys
    width: 'fit-content', // eslint-disable-line no-dupe-keys
    minWidth: 'calc(100% - 16px)',
  },
  dropdownItem: {
    'ul$dropdownOptions li&': {
      marginLeft: 0,
    },
    borderTopLeftRadius: 2,
    borderTopRightRadius: 2,
    borderBottom: `1px solid ${theme.colors.borderDropdown}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  dropdownButton: {
    ...buttonReset({
      padding: [20, 16],
      whiteSpace: 'nowrap',
      color: theme.colors.brandBlack,
      display: 'block',
      margin: 0,
      cursor: 'pointer',
      backgroundColor: theme.colors.white,
      width: '100%',
      textAlign: 'left',
      transition: 'color 300ms',
      outline: 0,
      fontSize: 14,
      '$dropdownItem &': {
        fontFamily: theme.fonts.body,
      },
      letterSpacing: 0.3,
      lineHeight: '16px',
      '&:hover,&:focus,&:active': {
        color: theme.colors.brandBlack,
        backgroundColor: theme.colors.ui03,
      },
      '&.active': {
        fontWeight: 600,
        backgroundColor: theme.colors.blue50,
      },
    }),
  },
  dropDownClose: {
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 99997,
  },
  iconWrapper: {
    display: 'inline-block',
    position: 'absolute',
    top: 'calc(50% - 4px)',
    right: 10,
    pointerEvents: 'none',
  },
  button: {
    ...buttonReset({
      outline: 0,
      padding: [10, 32, 10, 10],
      letterSpacing: 2,
      lineHeight: 'normal',
      width: '100%',
      textAlign: 'left',
      cursor: 'pointer',
      '&::after': {
        borderBottomWidth: 2,
      },
    }),
  },
  icon: {
    display: 'block',
    width: 20,
    height: 8,
  },
})(DropDown);
